import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { LoadingPanel } from "../../components/layout/Loading";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { getAllBookingReference } from "./services/bookingreference.services";

const BookingReference: React.FC = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    return () => {
      dispatch(setCurrentPage(0));
    };
  }, [dispatch]);

  return (
    <>
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Booking Reference List
          </Typography.h4>
        </GridLayoutItem>
        <GridLayoutItem>
          <BookingReferenceGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const BookingReferenceGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();

  const BookingReferenceList = useAppSelector(
    (state) => state.bookingReference.BookingReferenceList,
  );
  const loading = useAppSelector((state) => state.bookingReference.loading);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterBookingReference = useAppSelector(
    (state) => state.bookingReference.FilterBookingReference,
  );
  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  useEffect(() => {
    const payload = {
      ...FilterBookingReference,
      Limit: +pageLimit,
      Skip: +currentPage * +pageLimit,
    };
    dispatch(getAllBookingReference(payload));
  }, [currentPage, pageLimit, FilterBookingReference, dispatch]);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  // const BookingReferenceFilterCell = React.useCallback(
  //   (props: GridCustomFilterCellProps) => (
  //     <CommonFilterCell
  //       {...props}
  //       filterSelector={(state) =>
  //         state.bookingReference.FilterBookingReference
  //       }
  //       setFilterAction={setFilterBookingReference}
  //       clearFilterAction={clearFilterBookingReference}
  //       fetchDataAction={getAllBookingReference}
  //       pagination={{ case: "capitalize" }}
  //     />
  //   ),
  //   [],
  // );

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        style={{ maxHeight: "calc(100vh - 152px)" }}
        filterable={true}
        className="responsive-table"
        filter={filter}
        data={
          filter ? filterBy(BookingReferenceList, filter) : BookingReferenceList
        }
        onFilterChange={handleFilterChange}
        total={
          BookingReferenceList[0]?.ItemCount ||
          BookingReferenceList[0]?.itemcount ||
          BookingReferenceList.length
        }
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="CreatedOn"
          title="Date Time"
          width={180}
          filterable={false}
        />
        <Column field="City" title="City" width={150} filterable={true} />
        <Column
          field="RoomName"
          title="Room Name"
          filterable={false}
          width={280}
        />
        <Column
          field="URL"
          title="Booking URL"
          filterable={false}
          cells={{
            data: (props) => (
              <td>
                <div style={{ cursor: "pointer" }}>
                  <Tooltip parentTitle={true}>
                    <a
                      href={props?.dataItem.URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary fw-semibold"
                      style={{ textDecoration: "none" }}
                      title={props?.dataItem.URL}
                    >
                      {props?.dataItem.URL}
                    </a>
                  </Tooltip>
                </div>
              </td>
            ),
          }}
        />
      </KendoGrid>
    </>
  );
};

export default BookingReference;
